import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { getRouteUrl } from '@utils/urls';

import { PRODUCT_AVAILABILITY } from '@common/routes';

import {
  Chevron,
  ContentLoggedOut,
  Text,
  Wrapper,
} from './StoreAvailability.styled';

const StoreAvailabilityLoggedOut = ({ slug, productColorId }) => {
  const { locale } = useRouter();
  const { t } = useTranslation('common');

  return (
    <Link
      legacyBehavior
      href={{
        pathname: PRODUCT_AVAILABILITY,
        query: { id: productColorId, slug },
      }}
      as={getRouteUrl(locale, PRODUCT_AVAILABILITY, {
        id: productColorId,
        slug,
      })}
      passHref
      shallow
    >
      <Wrapper data-testid="search-stores-toggle" id="availability-check">
        <ContentLoggedOut>
          <Text>
            {t('productDetails.availableLoggedOut', 'Filialen-Verfügbarkeit')}
          </Text>
          <Chevron />
        </ContentLoggedOut>
      </Wrapper>
    </Link>
  );
};

StoreAvailabilityLoggedOut.propTypes = {
  productColorId: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

export default StoreAvailabilityLoggedOut;
